import {createFileRoute} from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_protected/home/accounts/credits/$accountId/bonus-shop',
)({
  staticData: {crumbKey: 'navigation.bonus-shop'},
});
